const DashAuthError = ({ adminRole }) => {
  let message = 'You are not logged in. Please navigate to login URL to login.';
  
  if (adminRole === 'quiz_game') {
    message = 'You must be a Quiz Game admin to access this area.'
  }

  return (
    <>
      <h1>{message}</h1>
    </>
  )
}

export default DashAuthError
